export default [{
  id: 'call-agentname',
  sortId: 'agent_name',
  name: 'Agent name',
  style: { width: '33%' },
}, {
  id: 'call-clientname',
  sortId: 'client_last_name',
  name: 'Client name',
  style: { width: '33%' },
}, {
  id: 'call-controls',
  sortId: -1,
  name: 'Call tools',
  justify: 'center',
  style: { borderRight: '1px solid black', width: '33%' },
}, {
  id: 'enrollment-status',
  sortId: 'enrollment_status',
  name: 'Status',
  style: { borderLeft: '1px solid black', backgroundColor: '#E5F8FF' },
}, {
  id: 'enrollment-lastupdated',
  sortId: 'enrollment_date',
  name: 'Date',
  style: { backgroundColor: '#E5F8FF' },
}, {
  id: 'enrollment-id',
  sortId: 'enrollment_id',
  name: 'ID',
  style: { backgroundColor: '#E5F8FF', minWidth: '100px' },
}, {
  id: 'callinfo-starttime',
  sortId: 'call_start',
  name: 'Start time',
}, {
  id: 'callinfo-duration',
  sortId: 'call_duration',
  name: 'Duration',
}, {
  id: 'callinfo-type',
  name: 'Type',
}, {
  id: 'sentiment-agent',
  sortId: 'agent_sentiment',
  name: 'Agent',
}, {
  id: 'sentiment-client',
  sortId: 'caller_sentiment',
  name: 'Client',
}, {
  id: 'scriptadherence-confidence',
  sortId: 'trans_anal__transcript_confidence',
  name: 'Confidence',
}, {
  id: 'scriptadherence-overall',
  sortId: 'trans_anal__overall',
  name: 'Overall',
}, {
  id: 'scriptadherence-acknowledge',
  sortId: 'trans_anal__acknowledge',
  name: 'Acknowledge',
}, {
  id: 'scriptadherence-contact',
  sortId: 'trans_anal__contact',
  name: 'Contact',
}, {
  id: 'scriptadherence-medicare',
  sortId: 'trans_anal__medicare',
  name: 'Medicare',
}, {
  id: 'scriptadherence-eligibility',
  sortId: 'trans_anal__eligibility',
  name: 'Eligibility',
  justify: 'center',
}, {
  id: 'scriptadherence-payment',
  sortId: 'trans_anal__payment',
  name: 'Payment',
}, {
  id: 'scriptadherence-attest',
  sortId: 'trans_anal__attest',
  name: 'Attest',
}];
